import script from "./EnhancedOrderSubmitButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./EnhancedOrderSubmitButton.vue?vue&type=script&setup=true&lang=ts"

import "./EnhancedOrderSubmitButton.vue?vue&type=style&index=0&id=6a984a0e&scoped=true&lang=css"

import exportComponent from "../../../../eckpunkt-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a984a0e"]])

export default __exports__